import { IThoiKhoaBieuResponse } from "../../../model/respone/lop-tin-chi/IThoiKhoaBieuResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThoiKhoaBieuActionsObj = {
  SELECT_BY_KY_DANG_KY_START: {} as { kyDangKys: number[]},
  SELECT_BY_KY_DANG_KY_SUCCESS: {} as IThoiKhoaBieuResponse,
  SELECT_BY_KY_DANG_KY_ERRR: "",
};

export const eThoiKhoaBieuActionIds = generateActionTypeIds(
  eThoiKhoaBieuActionsObj,
  "THOI_KHOA_BIEU"
);

export type IThoiKhoaBieuActionTypes = IGenericActionType<
  typeof eThoiKhoaBieuActionsObj,
  "THOI_KHOA_BIEU"
>;
